import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appAppclosenotification]',
  standalone: true,
})
export class AppclosenotificationDirective {
  @Output() appClickOutside = new EventEmitter<void>();

  constructor(private _elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(target: any) {
    if (!this._elementRef.nativeElement.contains(target)) {
      this.appClickOutside.emit();
    }
  }
}
